<script lang="ts" setup>
	const emit = defineEmits<{
		(e: 'click'): void
	}>();

	defineProps<{
		negative?: boolean,
		loading?: boolean,
		neutral?: boolean
		text?: string,
    type?: 'button' | 'submit'
	}>();
</script>

<template>
	<button class="btn" :class="{ 'btn--neutral': neutral || loading, 'btn--loading': loading }" @click="emit('click')" :type="type || 'button'">
		<svg v-if="loading" class="btn__loader" viewBox="0 0 100 100">
      <circle cx="50" cy="50" fill="none" stroke="#85a2b6" stroke-width="15" r="32" stroke-dasharray="150.79644737231007 52.26548245743669">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
      </circle>
    </svg>
		<span class="btn__text">
			{{ text }}
		</span>
	</button>
</template>

<style scoped>

	.btn--loading .btn__text {
		opacity: 0;
		visibility: hidden;
	}

	.btn__loader {
		width: 25px;
		height: 25px;
		position: absolute;
	}

	.btn--loading {
		pointer-events: none;
	}

	.btn {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 4px;
		height: 55px;
		border-radius: 8px;
		background: #2563EB;
		box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.4);
		color: #fff;
		border: none;
		cursor: pointer;
		transition: 0.3s;
	}
	.btn:hover {
		background: #60A5FA;
	}

	/* .btn {
		cursor: pointer;
		margin: 0;
		border-radius: 8px;
		border: 1px solid #E2E8F0;
		background: #FFF;
		display: flex;
		width: 160px;
		height: 56px;
		padding: 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		flex-shrink: 0;
		color: #000;
		transition: 0.3s;
	}
	.btn:hover {
		transition: 0.3s;
		background: rgba(222, 224, 225, 0.22);
	} */
	.btn--neutral {
		box-shadow: none;
		border: 1px solid #E2E8F0;
		background: #FFF;
		color: #000;
	}

	.btn--neutral:hover {
		transition: 0.3s;
		color: #000;
		background: rgba(222, 224, 225, 0.22);
	}
</style>